import React, { useState } from "react";
import { DatePicker, Tooltip, Checkbox, Form, Input } from "antd";
import { FaQuestionCircle } from "react-icons/fa";
const { TextArea } = Input;

function MaintenanceInformation() {
  const [checked, setChecked] = useState(false);
  const onChange = () => {
    setChecked(!checked);
  };

  return (
    <>
      <Form.Item label="Maintenance Limit" name="maintenanceLimit">
        <Input prefix="$" />
      </Form.Item>

      <Form.Item name="insuranceExpiration" label="Insurance Expiration">
        <DatePicker style={{ width: "100%" }} placeholder="" />
      </Form.Item>

      <Form.Item
        label="Is it covered by home warranty?"
        name="homeWarranty"
        valuePropName="checked"
      >
        <Checkbox checked={checked} onChange={onChange} />
      </Form.Item>
      {checked && (
        <>
          <Form.Item
            required
            name="homeWarrantyCompany"
            label="Home Warranty Company"
          >
            <Input style={{ width: "100%" }} placeholder="" />
          </Form.Item>
          <Form.Item
            required
            name="homeWarrantyExpiration"
            label="Home Warranty Expiration"
          >
            <DatePicker style={{ width: "100%" }} placeholder="" />
          </Form.Item>
          <Form.Item required name="policyNumber" label="Policy Number">
            <Input style={{ width: "100%" }} placeholder="" />
          </Form.Item>
          <Form.Item required name="contactNumber" label="Contact Number">
            <Input style={{ width: "100%" }} placeholder="" />
          </Form.Item>
        </>
      ) }

      <Form.Item
        label={
          <span className="plain-text">
            Unit Entry Pre-authorized{" "}
            <Tooltip title="The tenant has pre-authorized entry for maintenance work as per lease clause.">
              <FaQuestionCircle size={12} className="circled-question" />{" "}
            </Tooltip>
          </span>
        }
        name="preAuthorized"
        valuePropName="checked"
      >
        <Checkbox></Checkbox>
      </Form.Item>
      <Form.Item label="Maintenance Notes" name="maintenanceNotes">
        <TextArea rows={4} />
      </Form.Item>
      <Form.Item
        label={
          <span className="plain-text">
            Online Maintenace Request Instructions{" "}
            <Tooltip title="This text will display at the top of the Maintenance Request screen in your residents' online portal.">
              <FaQuestionCircle size={12} className="circled-question" />{" "}
            </Tooltip>
          </span>
        }
        name="maintenanceInstructions"
      >
        <TextArea
          rows={4}
          placeholder="e.g In case of water leaks, do not file a maintenance requests, call (888) 555-5555."
        />
      </Form.Item>
    </>
  );
}

export default MaintenanceInformation;
